<template>
  <v-btn
    class="mt-3 text-subtitle-1 font-weight-bold"
    block
    color="#315ED9"
    dark
    type="submit"
    @submit.prevent="sendResetPasswordEmail"
    >{{ label }}</v-btn
  >
</template>

<script>
export default {
  name: 'SendResetPasswordEmailButton',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    sendPasswordResetEmail () {
      this.$emit('sendResetPasswordEmail')
    }
  }
}
</script>
